// FIXME this should really be exported from @avensia/excite module or allow translate to not return this string
const MISSING_TRANSLATION_PREFIX = 'Missing translation for';

export function translationExists(translation: string): boolean {
  return translation.startsWith(MISSING_TRANSLATION_PREFIX) ? false : true;
}
